/**
 * Public App Store URL for ClayPulse on iOS.
 * Change here to update every "Download on the App Store" link across the site.
 */
export const APP_STORE_URL = 'https://apps.apple.com/fr/app/claypulse/id6762091911';
export const APP_STORE_ID = '6762091911';
